export const TAILWINDCSS_LG_BREAKPOINT = 1024;
export const TAILWINDCSS_MD_BREAKPOINT = 768;
